import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';

@Component({
  standalone: true,
  selector: 'mode-export-dataset-error',
  imports: [SharedUtilToastModule],
  templateUrl: './export-dataset-error.component.html',
  styleUrls: ['./export-dataset-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
})
export class ExportDatasetErrorComponent extends Toast {}
